/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LightInputs */

const en_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

const fr_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clair`)
};

const de_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licht`)
};

const it_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggero`)
};

const ru_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свет`)
};

const es_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luz`)
};

const zh_cn2_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`光`)
};

const ja_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライト`)
};

const hi_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रोशनी`)
};

const pt_pt2_light = /** @type {(inputs: LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luz`)
};

/**
* | output |
* | --- |
* | "Light" |
*
* @param {LightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const light = /** @type {((inputs?: LightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_light(inputs)
	if (locale === "de") return de_light(inputs)
	if (locale === "it") return it_light(inputs)
	if (locale === "ru") return ru_light(inputs)
	if (locale === "es") return es_light(inputs)
	if (locale === "zh-CN") return zh_cn2_light(inputs)
	if (locale === "ja") return ja_light(inputs)
	if (locale === "hi") return hi_light(inputs)
	if (locale === "pt-PT") return pt_pt2_light(inputs)
	return en_light(inputs)
});